module.exports = __webpack_public_path__ + "img/bz.f8a4a622.png";